module.exports = __webpack_public_path__ + "static/media/golfer-4-b.2ee06f6c.png";